import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/format/format-byte.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/format/format-number.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/format/format-relative-time.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/format/format-time.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContext","AccordionItem","AccordionItemBody","AccordionItemContent","AccordionItemContext","AccordionItemIndicator","AccordionItemTrigger","AccordionPropsProvider","AccordionRoot","AccordionRootProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/accordion/accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["AlertContent","AlertDescription","AlertIndicator","AlertRoot","AlertPropsProvider","AlertTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/alert/alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/badge/badge.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlockquoteCaption","BlockquoteContent","BlockquoteIcon","BlockquotePropsProvider","BlockquoteRoot"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/blockquote/blockquote.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["IconButton"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/icon-button.js");
;
import(/* webpackMode: "eager", webpackExports: ["CardBody","CardDescription","CardFooter","CardHeader","CardPropsProvider","CardRoot","CardTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/card/card.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockAdapterProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block-adapter-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockCode","CodeBlockCodeText","CodeBlockCollapseIndicator","CodeBlockCollapseText","CodeBlockCollapseTrigger","CodeBlockContent","CodeBlockContext","CodeBlockControl","CodeBlockCopyIndicator","CodeBlockCopyTrigger","CodeBlockFooter","CodeBlockHeader","CodeBlockOverlay","CodeBlockRoot","CodeBlockTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block.js");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code/code.js");
;
import(/* webpackMode: "eager", webpackExports: ["Em"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/em/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Float"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/float/float.js");
;
import(/* webpackMode: "eager", webpackExports: ["GridItem"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/grid/grid-item.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/heading/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/image/image.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ListIndicator","ListItem","ListRoot","ListRootPropsProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/list/list.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/separator/separator.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/simple-grid/simple-grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["HStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/h-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["VStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/v-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["StatDownIndicator","StatHelpText","StatLabel","StatPropsProvider","StatRoot","StatUpIndicator","StatValueText","StatValueUnit"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stat/stat.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Wrap"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/wrap/wrap.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/competitions/OrganizerCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/competitions/RefundPolicyText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/BookmarkIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompetitorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoCloseDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoOpenDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DetailsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_222Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333fmIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mbfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mboIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ohIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_666Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_777Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_ClockIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_FtoIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MinxIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MmagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_PyramIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_SkewbIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_Sq1Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/LocationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MapIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/OnTheSpotRegistrationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/PaymentIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpectatorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpotsLeftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/VenueIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LocalDateTime.tsx");
